import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ad6c966"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "h1-text" }
const _hoisted_4 = { class: "about-tutor" }
const _hoisted_5 = { class: "requisites-section" }
const _hoisted_6 = { class: "h1-text" }
const _hoisted_7 = { class: "about-tutor" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "  https://tutor-de-ensino-ts.vercel.app/",
  target: "_blank"
}, " https://tutor-de-ensino-ts.vercel.app/ ", -1))
const _hoisted_9 = { class: "test-smells-available" }
const _hoisted_10 = { class: "h1-text" }
const _hoisted_11 = { class: "about-tutor" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "links" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "links" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://github.com/apache/commons-codec",
        target: "_blank"
      }, " https://github.com/apache/commons-codec")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://github.com/apache/commons-math.git",
        target: "_blank"
      }, " https://github.com/apache/commons-math.git")
    ])
  ])
], -1))
const _hoisted_13 = { class: "development-team-div" }
const _hoisted_14 = { class: "h1-text" }
const _hoisted_15 = { class: "development-team" }

import DeveloperCard from "@/components/DeveloperCard.vue";
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutPage',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)('aboutPage.about')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('aboutPage.aboutTutor')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(t)('aboutPage.requirements')), 1),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_unref(t)('aboutPage.requirementsInfo')) + " ", 1),
            _hoisted_8
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h1", _hoisted_10, _toDisplayString(_unref(t)('aboutPage.datasets')), 1),
          _createElementVNode("div", _hoisted_11, [
            _createTextVNode(_toDisplayString(_unref(t)('aboutPage.datasetsInfo')) + " ", 1),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h1", _hoisted_14, _toDisplayString(_unref(t)('aboutPage.developmentTeam')), 1),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(DeveloperCard, {
              nick: "DeigelaLima",
              foto: require('@/assets/team/Foto-Deigela.jpeg'),
              descricao: _unref(t)('aboutPage.developmentTeamInfo.deigela'),
              nome: "Deigela Lima",
              email: "deigelalima@hotmail.com"
            }, null, 8, ["foto", "descricao"]),
            _createVNode(DeveloperCard, {
              nick: "Joaopfq",
              foto: require('@/assets/team/Foto-Joao.jpeg'),
              descricao: _unref(t)('aboutPage.developmentTeamInfo.joao'),
              nome: "João Paulo",
              email: "joaop3595@gmail.com"
            }, null, 8, ["foto", "descricao"]),
            _createVNode(DeveloperCard, {
              nick: "larasouzabr",
              foto: require('@/assets/team/Foto-Lara.jpeg'),
              descricao: _unref(t)('aboutPage.developmentTeamInfo.lara'),
              nome: "Lara Souza",
              email: "laragabrielly@alu.ufc.br"
            }, null, 8, ["foto", "descricao"]),
            _createVNode(DeveloperCard, {
              nick: "ovictorpa",
              foto: require('@/assets/team/Foto-Victor.png'),
              descricao: _unref(t)('aboutPage.developmentTeamInfo.victor'),
              nome: "Victor Anthony",
              email: "victorpa@alu.ufc.br"
            }, null, 8, ["foto", "descricao"]),
            _createVNode(DeveloperCard, {
              foto: require('@/assets/team/Foto-Carla.jpg'),
              descricao: _unref(t)('aboutPage.developmentTeamInfo.carla'),
              nome: "Carla Bezerra",
              email: "carlailane@ufc.br"
            }, null, 8, ["foto", "descricao"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})